module.exports = "<div class=btn>&nbsp; <cn-distribution-bar class=\"bar manager\" ng-if=vm.managerHasPoints() ng-style=\"{left: vm.calculatePosition(vm.managerPoints) + '%'}\" ng-class=vm.managerClass></cn-distribution-bar> <cn-distribution-bar class=\"bar employee\" ng-if=vm.employeeHasPoints() ng-style=\"{left: vm.calculatePosition(vm.employeePoints) + '%'}\"></cn-distribution-bar> <cn-distribution-bar class=\"bar ambition\" ng-if=vm.performanceHasPoints() ng-style=\"{left: vm.calculatePosition(vm.performancePoints) + '%'}\"></cn-distribution-bar> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-distribution-box/cn-distribution-box.html
 ** module id = 59
 ** module chunks = 0
 **/